import React, { Component } from "react";
import "./App.css";
import gtag from "./gtag";
export default class App extends Component {
  componentDidMount() {
    gtag("js", new Date());

    gtag("config", "UA-73755675-24");
  }

  render() {
    return (
      <div className="app">
        <div className="cardsContainer">
          <div>
            <figure className="gloss">
              <img
                src="https://cdn.battlerite.com/www3/images/static/bg/battlerite_card.png"
                alt="arena"
                draggable={"false"}
                onClick={() => {
                  gtag("event", "arena_nav");
                  window.location.href = "https://arena.battlerite.com";
                }}
              />
            </figure>
          </div>
          <div>
            <figure className="gloss">
              <img
                src="https://cdn.battlerite.com/www3/images/static/bg/royale_card.png"
                alt="royale"
                draggable={"false"}
                onClick={() => {
                  gtag("event", "royale_nav");
                  window.location.href = "https://royale.battlerite.com";
                }}
              />
            </figure>
          </div>
        </div>
        <div className="bp">
          <figure>
            <div>
              <img
                src="https://cdn.battlerite.com/www3/images/static/battlepass/season3/BattlePass_season3_button2.png"
                alt="arena"
                draggable={"false"}
                onClick={() => {
                  gtag("event", "battlepass_nav");
                  window.location.href = "https://battlerite.com/battlepass";
                }}
              />
            </div>
          </figure>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js